// extracted by mini-css-extract-plugin
export default {"settingsItem":"index_settingsItem__pu7gn","label":"index_label__LhU8P","valueContainer":"index_valueContainer__gzOB1"};